import { restRequest } from "vrcore-dashboard/dist/utilities";
export const SLG_CHECKLIST_GET_REPORT = restRequest(
    "VRCORE.SLG_SINGLE_BOX_CHECKLIST_GET_REPORT"
);
export const SLG_CHECKLIST_SUBMIT_REPORT_CHANGES = restRequest(
    "VRCORE.SLG_SINGLE_BOX_CHECKLIST_SUBMIT_REPORT_CHANGES"
);
